import React from 'react';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { shutdownHistoryQuery } from '../../../../../shared/api/queries';
import ChangingHistory, {
  historyModes,
} from '../../../../../../../components/ChangingHistory/ChangingHistory';

const { useShutdownHistory } = shutdownHistoryQuery;

const HistoryModal = () => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const visible = type === modalTypes.shutdownHistory;
  const { data, isFetching } = useShutdownHistory(shutdown.alertId, {
    staleTime: 1000 * 60,
    enabled: visible && Boolean(shutdown.alertId),
  });

  return (
    <ChangingHistory
      mode={historyModes.all}
      visible={visible}
      onCancel={close}
      title={`История изменений отключения ${shutdown.alertId ?? ''}`}
      loading={isFetching}
      items={data}
      modalProps={{ destroyOnClose: true }}
    />
  );
};

export default HistoryModal;
